/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import { Card, Checkbox, Col, DatePicker, Radio, TimePicker } from "antd";
import PageToolbar from "../../components/PageToolbar";
import Form from "antd/es/form/Form";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import DateTimePicker from "../../components/DateTimePicker";
import { Row } from "antd/es/grid";
import ReportTypeButton from "../../components/ReportTypeButton";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import { Job, OutputType, ProcessType, User } from "../../JmReact";

class BranchAdminSummary extends Component {
    constructor(props: Props) {
        super(props);

        this.state = {
            _BranchList: "",
            _SupplierList: "",
            _MethodList: "",

            isDaily: '1',//'0', // דני ביקש לשנות 2025-11-23
            _year: null,// moment().format("YYYY"),
            _month: null,// moment().format("MM"),
            _date: moment().format("YYYY-MM-DD"), // null,
            _time: "00:00:00",

            _viewPayments: 1,
            _viewCredits: 1,
            _viewPayItems: 1,
            _viewPayCredits: 0,
            _viewOrdersMethods: 1,
            _viewOrdersSuppliers: 1,
            _viewGraph1: 1,
            _viewMethodsPayCount: 1,
            _viewMethodsPaySum: 1,
            _viewSuppliersPayCount: 1,
            _viewSuppliersPaySum: 1,
            PosId: 999,
            reportName: "reports/Report80BranchAdminSummary.pdf",
        };

        this.filterSuppliers = '1,2,3,4,7,48,76';

        this.selectors = [
            { id: TableIDs.genericSelectorExternalOrderSuppliers, api: 'external_orders_supplier_logo_list' },
            { id: TableIDs.genericSelectorDeliveryMethods, api: 'delivery_methods_list_all' },
        ]

        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector };
        })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        if (!this.props.ui.favoriteParams) {

            this.sendAPI("get_all_gp_by_user", "", ob => {
                if (ob.data) {
                    ob.data.split("\r").forEach(x => {
                        let y = x.split("\f");
                        if (y[0] == 'GP_StartDayHour' && y[1] && y[1].length == 5) {
                            this.setState({ _time: y[1] + ":00" })
                        }
                    })
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(21183);

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState({ ...this.props.ui.favoriteParams })
        }
    }

    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCallback, e => { console.error(e) });
    }


    getCheckboxField = (label, field, pie1, pie2, readOnly) => {
        return (<Form.Item>
            <Checkbox checked={this.state[field] == 1} onChange={e => {
                if (!readOnly) {
                    if (e.target.checked) this.setState({ [field]: 1 })
                    else this.setState({ [field]: 0, [pie1]: 0, [pie2]: 0 })
                }
            }}>{label}</Checkbox>
            {pie1 ? <Checkbox checked={this.state[pie1] == 1} onChange={e => { this.setState({ [pie1]: e.target.checked ? 1 : 0 }) }}>{this.getText(21193)}</Checkbox> : ""}
            {pie2 ? <Checkbox checked={this.state[pie2] == 1} onChange={e => { this.setState({ [pie2]: e.target.checked ? 1 : 0 }) }}>{this.getText(21194)}</Checkbox> : ""}
        </Form.Item>)
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };


        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={gt(21183)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: window.innerWidth < 1400 ? '95%' : 1400 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}>
                <Row>
                    <Col span={window.innerWidth > 600 ? 8 : 24}>
                        {this.getCheckboxField(gt(21186), '_viewPayments', 0, 0, 1)}
                        {this.getCheckboxField(gt(21187), '_viewCredits')}
                        {this.getCheckboxField(gt(21188), '_viewPayItems')}
                        {this.getCheckboxField(gt(21189), '_viewGraph1')}
                        <hr />
                        {/* {this.getCheckboxField(gt(21190), '_viewPayCredits')}
                        <hr /> */}
                        {this.getCheckboxField(gt(21191), '_viewOrdersMethods', '_viewMethodsPayCount', '_viewMethodsPaySum')}
                        <hr />
                        {this.getCheckboxField(gt(21192), '_viewOrdersSuppliers', '_viewSuppliersPayCount', '_viewSuppliersPaySum')}

                    </Col>
                    <Col span={window.innerWidth > 600 ? 8 : 24} style={{ paddingRight: window.innerWidth > 600 ? 25 : 0 }}>
                        {/*
                        <Form.Item label={gt(21184)}>
                             <GenericSelectorBranches {...this.props} multi
                                value={this.state._BranchList ? this.state._BranchList.split(",") : []}
                                onChange={e => { this.setState({ _BranchList: e ? e.join(",") : "" }) }}
                            /> 
                            </Form.Item>
                            */}
                        {/* דני ביקש לשנות 2025-11-23 */}
                        <Form.Item label={gt(21184)} required validateStatus={this.state._BranchList ? "success" : "error"}>
                            <GenericSelectorBranches {...this.props}
                                value={this.state._BranchList}
                                onChange={e => { this.setState({ _BranchList: e }) }}
                            />
                        </Form.Item>
                        <Form.Item label={gt(21203)}>
                            <GenericSelector {...this.props} multi {...this.selectors[0]}
                                filterList={this.filterSuppliers.split(',')}
                                value={this.state._SupplierList ? this.state._SupplierList.split(",") : []}
                                onChange={(e) => { this.setState({ _SupplierList: e?.join(",") }) }}
                            />
                        </Form.Item>

                        <Form.Item label={gt(21204)}>
                            <GenericSelector {...this.props} multi {...this.selectors[1]}
                                value={this.state._MethodList ? this.state._MethodList.split(",") : []}
                                onChange={(e) => { this.setState({ _MethodList: e?.join(",") }) }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={window.innerWidth > 600 ? 8 : 24} style={{ paddingRight: window.innerWidth > 600 ? 25 : 0 }}>

                        <Form.Item>
                            <Radio.Group
                                value={this.state.isDaily}
                                onChange={e => {
                                    this.setState({
                                        isDaily: e.target.value,
                                        _date: e.target.value == 1 ? moment().format("YYYY-MM-DD") : null,
                                        _year: e.target.value == 0 ? moment().format("YYYY") : null,
                                        _month: e.target.value == 0 ? moment().format("MM") : null
                                    })
                                }}>
                                <Radio value={"1"}>{gt(21205)}</Radio>
                                <Radio value={"0"}>{gt(21206)}</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item label={gt(this.state.isDaily == 1 ? 21207 : 21185)}>
                            {this.state.isDaily == 1 ?
                                <DateTimePicker format="DD/MM/YYYY"
                                    value={this.state._date}
                                    onChange={e => { this.setState({ _date: e }) }}
                                /> :
                                <DatePicker.MonthPicker format="MM/YYYY"
                                    value={moment(this.state._year + "-" + this.state._month + "-01")}
                                    onChange={e => {
                                        this.setState({
                                            _year: moment(e).format("YYYY"),
                                            _month: moment(e).format("MM"),
                                        })
                                    }}
                                />}
                        </Form.Item>

                        <Form.Item label={gt(21210)}>
                            <DateTimePicker format="HH:mm" value={this.state._time} onChange={(e) => { this.setState({ _time: e }) }} />
                        </Form.Item>

                        <ReportTypeButton
                            {...this.props}
                            params={this.state}
                            // branchesField={'_BranchList'}
                            /* דני ביקש לשנות 2025-11-23 */
                            disabled={!this.state._BranchList}
                            datesToFavorites={this.state.isDaily == 1 ? [
                                { field: '_date', label: this.getText(21207) }
                            ] : [
                                { fields: ["_month", "_year"], label: gt(21185), format: 2 }
                            ]}
                            favoriteSave
                        />
                    </Col>
                </Row>

            </Card>
        </div>)
    }

}

export default BranchAdminSummary;